
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

declare global {
  interface Window { cdnUrl: string }
}

@Component({
  inheritAttrs: false
})

export default class BaseImage extends Vue {
  @Prop() readonly src!: string
  @Prop({ default: true }) readonly showLoadingSpinner: boolean | undefined

  private showSpinnerDelayTimeout?: number;

  mounted () {
    if (!this.isLoaded) {
      this.$emit('loading', this.src)
    }
  }

  private imgBaseUrl = window.cdnUrl

  public isLoaded = false

  public imageLoad () {
    if (this.showSpinnerDelayTimeout) {
      clearTimeout(this.showSpinnerDelayTimeout)
      this.showSpinnerDelayTimeout = undefined
      this.isLoaded = false
    }

    if (!this.isLoaded) {
      this.isLoaded = true
      this.$emit('loaded', this.src)
    }
  }

  public imageError () {
    console.log('Failed to load: ' + this.srcUrl)
    this.imageLoad()
  }

  get srcUrl (): string {
    return this.isRelative ? this.imgBaseUrl + this.src : this.src
  }

  get isRelative (): boolean {
    return this.src.length > 0 && this.src[0] !== '/'
  }

  @Watch('srcUrl')
  onSrcChanged (val: string, oldVal: string) {
    if (val !== oldVal) {
      if (!this.isLoaded) {
        this.$emit('loaded', oldVal)
      }
      this.$emit('loading', this.src)
    }
    this.showSpinnerDelayTimeout = setTimeout(() => { this.isLoaded = val === oldVal }, 250)
  }
}
